// extracted by mini-css-extract-plugin
export default {"tab":"NavTab_tab__SWDnw","active":"NavTab_active__6fpE1","total":"NavTab_total__uHA4s"};